import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ButtonComponent from '../../../components/common/button/Button';
import WorkFlowStatusModel from '../WorkflowManagement/WorkFlowStatus';
import { DateComparator } from '../../../components/common/DateComparator';
import { PercentComparator } from '../../../components/common/PercentComparator';
import { currencyComparator, DaysComparator } from '../../../components/common/DaysComparator';

export const AdminPendingApprovalHeaders = (onChangeConfidenceLevel, navigate, getWorkFlowData, activeItem, landingTitle, role, handleOpenViewAllModal, handleOpenLeadTime) => {
  
  return [
    {
      field: "supplierId",
      headerName: "Supplier",
      pinned: 'left',
      lockPinned: true,
      lockPosition: true,
      width: 130,
    },
    {
      field: "materialId", headerName: "Material", pinned: 'left',
      lockPinned: true,
      lockPosition: true, width: 130,
      cellRenderer: (response) => {
        return (
          <span><a href={`${process.env.REACT_APP_SAP_FIORI_MATERIAL_MASTER_DISPLAY_BASE_URL}?sap-client=010&sap-language=EN#Material-display?Material=${response?.value}`} target="_blank" style={{ color: '#000', cursor: 'pointer' }}>{response?.value || "-"}</a></span>
        )
      }
    },
    {
      field: "incotermLocation", headerName: "Incoterm Location", pinned: 'left',
      lockPinned: true,
      lockPosition: true, width: 150,
    },
    {
      field: "plant", headerName: "Plant",
      pinned: 'left',
      lockPinned: true,
      lockPosition: true, width: 110,
    },
    { field: "supplierName", headerName: "Supplier Name", optionalField: true },
    { field: "materialDescription", headerName: "Material Description", optionalField: true },
    { field: "shipToCity", headerName: "Ship To City", optionalField: true },
    { field: "purchGroup", headerName: "Purchasing Group", optionalField: true },
    { field: "mrpController", headerName: "MRP Controller", optionalField: true },
    { field: "snpPlanner", headerName: "SNP Planner", optionalField: true },
    { field: "snpPlannerDescription", headerName: "SNP Planner Description", optionalField: true },
    { field: "inventoryClass", headerName: "Inventory Classification", optionalField: true },
    { field: "purchDocType", headerName: "Purchasing Document Type", optionalField: true },
    { field: "shipToCountry", headerName: "Ship To Country", optionalField: true },
    { field: "incoterm", headerName: "Incoterm", optionalField: true },
    { field: "masterLt", headerName: "Material Master Lead Time", optionalField: true, comparator: DaysComparator, },
    {
      field: "contractLt", headerName: "Contract Lead Time",
      comparator: DaysComparator,
      cellRenderer: (response) => {
        return (
          (response?.value === "NA" || response?.value === null || response?.value === undefined || response?.value === "" || response?.value === "-") ?
            <div>
              {" "}
              <span>{response.value}</span>
            </div>
            :
            <div>
              {" "}
              <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => handleOpenLeadTime(response.data, "ContractsLeadTime")} >{response.value}</span>
            </div>
        )
      }
    },
    {
      field: "activePirLt", headerName: "PIR Lead Time",
      comparator: DaysComparator,
      cellRenderer: (response) => {
        return (
          (response?.value === "NA" || response?.value === null || response?.value === undefined || response?.value === "" || response?.value === "-") ?
            <div>
              {" "}
              <span>{response.value}</span>
            </div>
            :
            <div>
              {" "}
              <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => handleOpenLeadTime(response.data, "PIRLeadTime")} >{response.value}</span>
            </div>
        )
      }
    },
    { field: "palletChange", headerName: "Pallet Requirement Change" },
    { field: "palletPositioningImpact", headerName: "Pallet Positioning Impact (%)" },
    {
      field: "demonstratedLt", headerName: "Demonstrated Lead Time (Planned)",
      comparator: DaysComparator,
      cellRenderer: (response) => {
        // Combine two objects
        const combinedObject = {
          data: response.data,
          activeItem: activeItem,
          landingTitle: landingTitle,
          role: role
        };
        return (
          <div>
            {" "}
            <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => navigate('/admin-analytics-results-details', { state: { combinedObject } })} >{response.value}</span>
          </div>
        )
      }
    },
    { 
      field: "demonstratedLeadTimeActual", 
      headerName: "Demonstrated Lead Time (Actual)", 
      tooltipValueGetter: (params) => {
        const actualArrival = params.data?.actualArrivalDate || "";
        const actualShip = params.data?.actualShipDate || "";
        return `Arrival: ${actualArrival}\nDeparture: ${actualShip}`;
      },
      comparator: DaysComparator,
      cellRenderer: (response) => {
        // Combine two objects
        const combinedObject = {
          data: response.data,
          activeItem: activeItem,
          landingTitle: landingTitle,
          role: role
        };
        return (
          <div>
            {" "}
            <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => navigate('/admin-analytics-results-details', { state: { combinedObject } })} >{response.value}</span>
          </div>
        )
      }
    },
    { field: "transitTimeActual", headerName: "Transit Variance" },
    { field: "dataQualityStatus", headerName: "Data Quality Status" },
    {field: "iqdTime", headerName: "IQD"},
    {field: "manufacturingLeadTime", headerName: "Manufacturing Lead Time"},
    {field: "transitTimeTm", headerName: "Transit Time"},
    // { field: "ltVariations", headerName: "Lead Time Variations" },
    {field: "ltVariations", headerName: "Lead Time Variations"},
    { field: "ltInitiatedBy", headerName: "Analytics Initiated by" },
    {
      field: "updatedAt", headerName: "Results Updated at", optionalField: true,
      comparator: DateComparator,
      // filter: 'agDateColumnFilter',
    },
    // {
    //   field: "recomConfidenceLevel", headerName: "% of orders with lower than recommended lead time",
    //   width: 280,
    //   editable: (params) => role === "Admin" ? false : params?.data?.currentApprovalLevel === 0 ? true : false,
    //   cellEditor: 'agSelectCellEditor',
    //   cellEditorParams: {
    //     values: ["85%", "75%", "65%"]
    //   },
    //   cellClass: 'confidenceLevel-cell-height',
    //   cellStyle: (params) => {
    //     if(role==="Admin"){
    //       return { backgroundColor: "#bcbcbc", pointerEvents: "none" };
    //     }
    //     if (role!=="Admin"&&params?.data?.currentApprovalLevel !== 0) {
    //       return { backgroundColor: "#bcbcbc", pointerEvents: "none" };  // Apply the color for non-editable rows
    //     }
    //     return null;  // No style for editable rows
    //   },
    //   valueSetter: (params) => {
    //     if (params.newValue !== params.oldValue) {
    //       const dataCopy = { ...params.data, recomConfidenceLevel: params.newValue };
    //       params.node.setData(dataCopy);
    //       return true;
    //     }
    //     return false;
    //   },
    //   onCellValueChanged: onChangeConfidenceLevel,
    //   cellRenderer: (params) => {
    //     return <div className="confidenceLevel_drp-icon" ><span style={{ flex: 1, padding: '0px 4px' }}>{params.value} </span><ArrowDropDownIcon /></div>;
    //   }

    // },
    // {
    //   field: "finalLt", headerName: "Recommended LT to be Updated in S/4", 
    //   editable: (params) => role === "Admin" ? false : params?.data?.currentApprovalLevel === 0 ? true : false,
    //   cellStyle: (params) => {
    //     if(role==="Admin"){
    //       return { backgroundColor: "#bcbcbc", pointerEvents: "none" };
    //     }
    //     if (role!=="Admin"&&params?.data?.currentApprovalLevel !== 0) {
    //       return { backgroundColor: "#bcbcbc", pointerEvents: "none" };  // Apply the color for non-editable rows
    //     }
    //     return null;  // No style for editable rows
    //   },
    //   cellClass: "finalLT-cell",
    //   cellEditor: 'agNumberCellEditor',
    //   cellDataType: 'number',
    //   // onCellValueChanged: (params) => {
    //   //   console.log('Cell value changed:', params);
    //   // },
    //   valueSetter: (params) => {
    //     if (params.newValue !== Number(params.oldValue)) {
    //       const dataCopy = { ...params.data, finalLt: params.newValue };
    //       params.node.setData(dataCopy);
    //       return true;
    //     }
    //     return false;
    //   },

    //   cellRenderer: (params) => {
    //     return <div className="finalLT_drp-icon"  ><span style={{ flex: 1, padding: '0px 4px' }}>{params.value} </span><EditIcon /></div>

    //   },
    // },
    {
      field: "recomConfidenceLevel", headerName: "% of orders with lower than recommended lead time", width: 280,
      comparator: PercentComparator,
    },
    { field: "finalLt", headerName: "Recommended LT to be Updated in S/4", width: 280, },
    {
      field: "inventoryValue", headerName: "Potential Inventory Impact (Cost Value)",
      comparator: currencyComparator,
      cellRenderer: (response) => {
        if (response?.data?.currency === "USD" || response?.data?.usdExchangeRate === null || response?.data?.usdExchangeRate === 0.0) {
          const value = `${response?.value} ${response?.data?.currency || ""}`
          return value;
        } else {
          const value = `${(response.value * response?.data?.usdExchangeRate).toFixed(2)} USD`;
          return value;
        }
      }
    },
    {
      field: "potentialImpact", headerName: "Potential Impact of New Lead Time on Stock", width: 280,
      comparator: PercentComparator,
      cellRenderer: (response) => {
        const value = response?.value?.replace("%", "").trim();
        return (
          <div style={{ display: 'flex' }}>
            <div style={{ width: '50px' }}>{response.value?.replace("-", "").trim()}</div>
            <div style={{ display: 'flex', alignItems: 'center' }}> {value >= 0 ? <ArrowUpwardIcon style={{ color: 'red', fontSize: 20 }} /> : <ArrowDownwardIcon style={{ color: 'green', fontSize: 20 }} />}</div>
          </div>
        )
      }
    },
    // { field: "recomBasedOn", headerName: "Recommendation Based" },
    { field: "transModeConsidered", headerName: "Mode of Transport Considered", optionalField: true },
    { field: "pendingApprovalSince", headerName: "Pending for Approval Since", optionalField: true },
    {
      field: "currentStatus", headerName: "Current Status", width: 250, cellRenderer: (response) => (
        <div style={{ textDecoration: "underline", cursor: "pointer" }}>
          {" "}
          <WorkFlowStatusModel data={response.data} value={response.value} />
        </div>
      ),
    },
    { field: "rejectReason", headerName: "Reject Reason" },
    { field: "runOutputSeqId", headerName: "ID" },
    {
      field: "View Input Details",
      width: 150,
      cellRenderer: (response) => (
        <div className="btn-wrapper">
          {" "}
          <ButtonComponent type="secondary" label="Input" onClick={() => handleOpenViewAllModal(response.data)} endIcon={<ArrowForwardIosIcon style={{ fontSize: 12 }} />} />

        </div>
      ),
      pinned: "right",
      lockPinned: true,
    },
  ]

}